var React = require('react');

function AboutShape (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1523 0L1366.66 17.4529L1126.21 36.7239C1023.22 49.4545 316.952 81.4644 230.048 93.4545C46.0096 118.846 49.0101 1013.09 -0.00012207 1024C-0.00012207 895.273 0.5 145.818 0.5 145.818V0H1523Z","fill":"url(#paint1_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint1_linear","x1":"761.5","y1":"0","x2":"761.5","y2":"100%","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#C32B5E","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#EF5A4B","key":1})]))]);
}

AboutShape.defaultProps = {"viewBox":"0 0 1508 1024","fill":"none"};

module.exports = AboutShape;

AboutShape.default = AboutShape;
